// Can also be included with a regular script tag
import Typed from 'typed.js';

const $wordsType = $('.js-words-type');

$wordsType.each(function() {
	const $this = $(this);
	const dataWordsStringsTarget = $this.data('words-strings-target');
	const dataWords = $this.data('words');
	const wordsArray = dataWords.split(',');

	let typed = new Typed(this, {
		strings: wordsArray,
		typeSpeed: 60,
		backSpeed: 40,
		loop: true,
		fadeOut: false,
		showCursor: false,
		contentType: 'null'
	});
})
